import "./App.css";
import { Route, Routes, HashRouter, Navigate } from "react-router-dom";
import { init, isInitialized } from "@fullstory/browser";
import Home from "./pages/Home";
import OnUninstallExtension from "./pages/OnUninstallExtension";
import { updateUserProperties } from "./common/full-story";
import { isPlgFeatureEnabled } from "./common/lpc";
import Signup from "./pages/Signup";

if (!isInitialized()) {
  console.log("Initialize Full Story ...");
  init(
    {
      orgId: process.env.REACT_APP_FULL_STORY_ORGANIZATION_ID,
    },
    () => {
      console.log("Full Story initialized");
      updateUserProperties({ email: "", firstName: "", lastName: "" });
    }
  );
}

function buildSignupRoute(path) {
  return isPlgFeatureEnabled() ?
    <Route path={path} element={<Signup />} /> :
    <Route path={path} element={<Navigate to="/" replace />} />
}

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        {buildSignupRoute("/signup/:lpcLoginUrl")}
        {buildSignupRoute("/signup")}
        <Route
          path="/on-uninstall-extension/:user"
          element={<OnUninstallExtension />}
        />
        <Route
          path="/on-uninstall-extension"
          element={<OnUninstallExtension />}
        />
      </Routes>
    </HashRouter>
  );
}
